<template>
  <div class="btn-upload">
    <el-row>
      <el-col :span="20">
        <input class="upload" type="file" @change="getBase64" :accept="accept">
        <el-input disabled="" placeholder="Add file" :size="size" style="margin-right: 5px"
                  v-model="fileName">
          <i class="el-icon-paperclip el-input__icon"
             slot="prefix">
          </i>
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" plain :size="size" style="position: absolute; top: 50%;transform: translate(-50%, -50%)"> Browse </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { get } from 'lodash'
export default {
  name: 'InputFileComponent',
  model: {
    prop: 'fileData',
    event: 'onSelectFile'
  },
  props: {
    fileData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    maxFileSize: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: 'default'
    },
    accept: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      fileName: ''
    }
  },
  watch: {
    fileData: function (newVal) {
      this.fileName = get(newVal, 'name', '')
    }
  },
  methods: {
    getBase64: function () {
      const input = event.target
      if (input.files && input.files[0]) {
        if (this.maxFileSize !== 0 && input.files[0].size > this.maxFileSize) {
          input.value = ''
          this.$emit('onErrorOverLimitFileSize')
          return false
        }

        const reader = new FileReader()
        reader.onload = (e) => {
          const fileData = {
            name: input.files[0].name,
            content: e.target.result
          }
          this.fileName = input.files[0].name
          this.$emit('onSelectFile', fileData)
          input.value = ''
        }

        reader.readAsDataURL(input.files[0])
      }
    }
  }
}
</script>
<style scoped>
  div.btn-upload {
    overflow: hidden;
    text-align: center;
    position: relative;
    margin: 0px;
    float: left;
    transition: all ease 0.2s;
    width: 100%;
    text-align: left;
  }

  input.upload {
    bottom: 0px;
    right: 0px;
    opacity: 0;
    width: 100%;
    height: 100%;
    outline: none;
    cursor: pointer;
    position: absolute;
    z-index: 100;
  }
</style>
